import React, { createContext, useContext, useMemo } from 'react';
import { useSucursalesUsuario, type SucursalesUsuarioState } from '../hooks/useSucursalesUsuario';

type SucursalesUsuarioContextValue = SucursalesUsuarioState;

const SucursalesUsuarioContext = createContext<SucursalesUsuarioContextValue | null>(null);

export const SucursalesUsuarioProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useSucursalesUsuario();
  const memo = useMemo(
    () => value,
    [
      value.sucursales,
      value.preferida,
      value.preferidaNro,
      value.preferidaSucursal,
      value.loading,
      value.error,
      value.sinAsignaciones,
      value.esAdmin,
      value.refresh,
    ]
  );
  return (
    <SucursalesUsuarioContext.Provider value={memo}>{children}</SucursalesUsuarioContext.Provider>
  );
};

const defaultContextValue: SucursalesUsuarioContextValue = {
  sucursales: [],
  preferida: null,
  preferidaNro: null,
  preferidaSucursal: null,
  loading: false,
  error: null,
  sinAsignaciones: false,
  esAdmin: false,
  refresh: async () => {},
};

export function useSucursalesUsuarioContext(): SucursalesUsuarioContextValue {
  const ctx = useContext(SucursalesUsuarioContext);
  return ctx ?? defaultContextValue;
}

export function useOperacionesSucursalBloqueadas(): boolean {
  const { sinAsignaciones, esAdmin, loading } = useSucursalesUsuarioContext();
  return !loading && sinAsignaciones && !esAdmin;
}

export function usePreferidaSucursal() {
  const { preferidaSucursal } = useSucursalesUsuarioContext();
  return preferidaSucursal;
}
